import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { proposalAPI } from '../../api/gms/proposal/proposal-api';
import { socketSetup } from '../../library/socket-io/socket-setup';
import { proposalAttachmentRequirementsAPI } from '../../api/gms/proposal-attachment-requirements/proposal-attachment-requirements-api';
import { useModalAccess } from '../../components/global/modal/use-modal-access';

interface SocketPayload {
    proposalId: number;
}

export const useRequiredSupportingDocumentsSocket = () => {
    const dispatch = useDispatch();
    const { currentProposalId } = useModalAccess();

    const invalidate = useCallback(
        ({ proposalId }: SocketPayload) => {
            dispatch(
                proposalAttachmentRequirementsAPI.util.invalidateTags([
                    { type: "ProposalFiles", id: proposalId },
                ])
            );
            dispatch(
                proposalAttachmentRequirementsAPI.util.invalidateTags([
                    { type: "ProposalFiles", id: "LIST" },
                ])
            );
            // Ignore updates for other proposals
            if (proposalId !== currentProposalId) return;

            dispatch(
                proposalAPI.util.invalidateTags([
                    { type: "Proposal", id: proposalId },
                ])
            );
        },
        [dispatch, currentProposalId]
    );

    useEffect(() => {
        if(!socketSetup) return 

        socketSetup.on("createApplication", invalidate)
        socketSetup.on("updateApplication", invalidate)
        socketSetup.on("updateApplicationStatus", invalidate)
        socketSetup.on("saveDraft", invalidate)
        socketSetup.on("setStatusChecking", invalidate)
        socketSetup.on("setStatusApproved", invalidate)
        socketSetup.on("setStatusBooked", invalidate)
        socketSetup.on("approveExtension", invalidate)
        socketSetup.on("rejectExtension", invalidate)
        socketSetup.on("requestExtension", invalidate)

        socketSetup.on("saveRates", invalidate)
        socketSetup.on("saveEvidenceNotes", invalidate)
        socketSetup.on("saveTotalAnnualPremium", invalidate)
        socketSetup.on("releaseApplication", invalidate)

        socketSetup.on("uploadInstallationRequirements", invalidate)
        socketSetup.on("updateInstallationRequirements", invalidate)
        socketSetup.on("updateApplicationStatus", invalidate)

        return () => {
            socketSetup.off("createApplication", invalidate)
            socketSetup.off("updateApplication", invalidate)
            socketSetup.off("updateApplicationStatus", invalidate)
            socketSetup.off("saveDraft", invalidate)
            socketSetup.off("setStatusChecking", invalidate)
            socketSetup.off("setStatusApproved", invalidate)
            socketSetup.off("setStatusBooked", invalidate)
            socketSetup.off("approveExtension", invalidate)
            socketSetup.off("rejectExtension", invalidate)
            socketSetup.off("requestExtension", invalidate)

            socketSetup.off("saveRates", invalidate)
            socketSetup.off("saveEvidenceNotes", invalidate)
            socketSetup.off("saveTotalAnnualPremium", invalidate)
            socketSetup.off("releaseApplication", invalidate)

            socketSetup.off("uploadInstallationRequirements", invalidate)
            socketSetup.off("updateInstallationRequirements", invalidate)
            socketSetup.off("updateApplicationStatus", invalidate)
        }
    }, [invalidate])
}